import { render, staticRenderFns } from "./Pft.vue?vue&type=template&id=387dcf2c&scoped=true"
import script from "./Pft.vue?vue&type=script&lang=js"
export * from "./Pft.vue?vue&type=script&lang=js"
import style0 from "./Pft.vue?vue&type=style&index=0&id=387dcf2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387dcf2c",
  null
  
)

export default component.exports